<template>
  <form class="chi-form chi-twofa" @submit.prevent="submit" v-show="!$root.logged_in">
    <div class="container">
      <chi-welcome></chi-welcome>
      <div class="chi-form-section right">
        <chi-announcements></chi-announcements>
        <div class="chi-form-section twofa-form">
          <h2 class="with-cropped-hr centered">Log Into Your Account</h2>
          <div class="chi-form-group chi-twofa-message">
            We sent {{message_type === 'email' ? 'an email' : 'a text mes&shy;sage'}} with a six&hyphen;digit se&shy;cu&shy;ri&shy;ty code to {{destination}}. Please en&shy;ter it here.
          </div>
          <div class="chi-twofa-errors" id="chi-twofa-notifications"
            data-conn-message="Failed to connect to server. Please try again later."
            data-fail-message="Invalid security code!"
            data-code-message="Security code cannot be blank!"
          ></div>
          <div class="chi-form-group chi-twofa-code" :class="{'has-chi-twofa-error': error.code}">
            <label class="chi-twofa-label" for="code">Security Code</label><br />
            <input class="k-textbox md" id="code" ref="code" tabindex="1" type="text" :name="random" :class="{'k-space-right': error.code}" v-model.lazy="model.code" v-if="code_visible" @keypress="onkeypress" />
            <i class="fal fa-fw fa-exclamation-circle chi-twofa-error-icon" :title="error.code ? 'Invalid or blank security code' : ''" v-if="error.code"></i><br />
          </div>
          <div class="chi-form-group chi-twofa-links" v-show="delay_reached">
            <a class="chi-link" id="resend_code" href="#" tabindex="2" v-show="error.code || delay_reached" @click="resend">Resend the security code to {{destination}}</a><br />
            <a class="chi-link" id="switch_method" href="#" tabindex="3" v-show="has_alternate && (error.code || delay_reached)" @click="resend">Send the security code by {{message_type === 'email' ? 'text message' : 'email'}} instead</a>
          </div>
          <div class="chi-form-group chi-twofa-trusted">
            <input class="k-checkbox" id="twofa-trusted" ref="twofa-trusted" tabindex="4" type="checkbox" v-model.lazy="model.trusted" />
            <label class="k-checkbox-label" for="twofa-trusted">This is a trus&shy;ted de&shy;vice. Don't ask for a code eve&shy;ry time.</label>
          </div>
          <div class="chi-button-group chi-form-group">
            <kendo-button class="chi-button-primary" id="login" sprite-css-class="chi-icon-log-in" tabindex="5" type="submit">Log In</kendo-button>
            <kendo-button id="clear" sprite-css-class="chi-icon-backspace" tabindex="6" type="reset" @click="clear()">Clear</kendo-button>
            <kendo-button class="chi-button-danger" id="cancel" sprite-css-class="chi-icon-cancel" tabindex="7" @click="cancel()">Cancel</kendo-button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>


<style lang="scss">
  .chi-form.chi-twofa {
    background: linear-gradient(to right, #3c4752 0 calc(50% + 21.14rem), #f8f8f9 calc(50% + 21.14rem) 100%);
    height: 100%;
    padding: 0;
    width: 100%;
    .container {
      height: 100%;
      margin: 0 auto;
      width: 97.14rem;
      &>.chi-form-section {
        float: left;
        height: 100%;
        padding: 2.286rem;
        position: relative;
        &.left {
          width: 69.71rem;
        }
        &.right {
          width: 27.43rem;
        }
        h1 {
          clear: initial;
          color: white;
          float: initial;
          height: 1em;
          font-size: 40px;
          font-weight: initial;
          margin: initial;
          margin-top: 5.714rem;
          padding: initial;
          text-transform: none;
          width: initial;
        }
        h2 {
          font-size: 20px;
          text-transform: uppercase;
        }
        .branding-container {
          .picture-frame {
            height: 14.29rem;
            margin: 2.286rem;
            width: 12.86rem
            img {
              height: 100%;
              width: 100%;
            }
          }
          p {
            color: white;
            line-height: 175%;
            margin-top: 1.143rem;
            a {
              color: inherit;
            }
          }
        }
        .cpt-wrapper {
          bottom: 2.286rem;
          left: 2.286rem;
          margin: 0;
          position: absolute;
          width: 65.14rem;
        }
        .cpt-container {
          color: rgba(128, 128, 128, 0.625);
          font-size: 10pt;
          float: left;
          width: 31.43rem;
          &.right {
            float: right;
          }
          p:first-of-type {
            font-weight: bold;
            text-decoration: underline;
          }
          p:not(:first-of-type) {
            font-style: italic;
          }
        }
        .chi-announcements {
          max-height: 47.5em;
          overflow: auto;
          .chi-announcement {
            color: #676d75;
            float: left;
            margin-top: 1.143rem;
            width: 100%;
            h3 {
              border-bottom: 1px solid rgba(0, 0, 0, 0.08);
              color: #4c8de0;
              font-size: 14px;
              margin: initial;
              padding: 0.2857rem;
              width: 100%;
              .chi-pub-date {
                color: #9c9c9c;
                display: inline-block;
                float: right;
                font-weight: normal;
              }
            }
          }
        }
        .chi-form-section.twofa-form {
          bottom: 2.286rem;
          height: auto;
          position: absolute;
          right: 3.429rem;
          width: 20.57rem;
          .chi-form-group {
            color: #676d75;
            margin-right: 0;
            width: 100%;
            label {
              text-align: left;
            }
          }
          .chi-twofa-message {
            line-height: normal;
            margin: 1.1429rem auto 0 auto;
          }
          .chi-twofa-code {
            margin: 1.1429rem 4.285rem 0 4.285rem;
            position: relative;
            width: 12rem;
            .chi-twofa-label {
              width: auto;
            }
          }
          .chi-twofa-links {
            height: 40px;
            line-height: normal;
            margin-top: 1.1429rem;
            text-align: center;
            width: 100%;
            .chi-link {
              color: #2f7abf;
            }
          }
          .chi-twofa-trusted {
            margin: 1.1429rem auto 0 auto;
            text-align: center;
            .k-checkbox {
              margin-right: 0.28571rem;
              margin-top: 0.92857rem;
              vertical-align: top;
            }
            .k-checkbox-label {
              line-height: normal;
              width: calc(100% - 1.5714rem);
            }
          }
          .chi-button-group {
            margin: 1.1429rem 0 2.1429rem 0;
            width: 100%;
            .k-button {
              float: none;
              #login, #clear {
                float: left;
              }
              #cancel {
                float: right;
              }
            }
          }
          .has-chi-twofa-error {
            .chi-twofa-label {
              color: #a22;
            }
            .k-textbox {
              border-color: #a22;
            }
            .chi-twofa-error-icon  {
              display: block;
            }
          }
          .chi-twofa-error-icon {
            bottom: 0.57143rem;
            color: #a22;
            display: none;
            margin: 0.5em 0 0 0;
            overflow: visible;
            position: absolute;
            right: 1.5rem;
            width: 0;
            &:before {
              color: #a22;
            }
          }
          .chi-twofa-errors {
            float: left;
            width: 100%;
            &.active {
              margin-top: 1.143rem;
            }
            .k-notification {
              width: 100%;
            }
          }
        }
      }
    }
  }
</style>


<script>
import $ from 'jquery';
import {Button} from '@progress/kendo-buttons-vue-wrapper';
import Announcements from './announcements';
import Welcome from './welcome';

export default {
  name: 'TwoFA',
  components: {
    'chi-announcements': Announcements,
    'chi-welcome': Welcome,
    'kendo-button': Button
  },
  data: function () {
    var hours = (new Date()).getHours();
    return {
      announcements: [],
      //announcements: [{
      //  date: Date.now(),
      //  title: 'Routine Maintenance',
      //  content: 'CCC Web Services will be down on Sunday, November 1<sup>st</sup>, between the hours of 8:00am&ndash;12:30pm for routine maintenance.'
      //}, {
      //  date: (new Date('05/01/2020')).getTime(),
      //  title: 'COVID-19',
      //  content: 'Until further notice, CCC is postponing all in-person Client meetings due to COVID-19.  Our hours of operations will remain 8:00am&ndash;4:30pm.  <strong>Stay safe and stay healthy!</strong>'
      //}],
      time_of_day:
        hours < 12 ? 'Morning' : (hours < 17 ? 'Afternoon' : 'Evening'),
      code_visible: true,
      delay_reached: false,
      delay_timeout: undefined,
      error: {code: undefined},
      model: {
        code: undefined,
        trusted: undefined
      }
    }
  },
  errors: undefined,
  notifications: undefined,
  methods: {
    onkeypress: function (event) {
      if (event.which > 31 && event.which < 127)
        try {
          switch (event.target.getAttribute('id')) {
          case 'code':
            this.error.code = undefined;
            break;
          default:
            console.warn('Unexpected field ' + event.target.getAttribute('id'));
            console.debug(event);
          }
        } catch (e) {
          console.error(e);
          console.debug(event);
        }
    },
    clear: function (reset, closing) {
      this.$options.notifications.hide();
      this.error.code = this.model.code = this.model.trusted = undefined;
      this.reset_delay();
      if (reset) {
        this.code_visible = false;
        this.code_visible = true;
      }
      if (!closing && this.$refs.code)
        this.$refs.code.focus();
    },
    cancel: function () {
      this.clear(true, true);
      this.$root.logout();
    },
    random: function () {
      return (new Date()).getTime().toString(16);
    },
    resend: function (event) {
      var self = this;
      $.ajax({
        contentType: 'application/json; charset=utf-8',
        data: JSON.stringify({
          switch_method: (event.target.id === 'switch_method')
        }),
        type: 'POST',
        url: '/resend?T=' + this.$root.token
      }).done(function (response) {
        self.destination = response.destination;
        self.message_type = response.message_type;
        self.clear(true);
      })
    },
    reset_delay: function () {
      var self = this;
      clearTimeout(this.delay_timeout);
      this.delay_reached = false;
      this.delay_timeout = setTimeout(function () {
        self.model.code = $('#code').val();
        self.delay_reached = true;
      }, 10000);
    },
    show_error: function (type) {
       this.$options.notifications.error(this.$options.errors.data(type));
    },
    submit: function () {
      var self = this;
      this.$options.notifications.hide();
      this.reset_delay();
      if (this.validate()) {
        kendo.ui.progress($('.chi-form-section.twofa-form'), true);
        $.ajax({
          contentType: 'application/json; charset=utf-8',
          data: JSON.stringify(this.model),
          type: 'POST',
          url: '/twofa?T=' + this.$root.token
        }).done(function () {
          self.clear();
          self.$root.login(function (connected) {
            if (!connected) {
              console.debug('socket connection failed');
              kendo.ui.progress($('.chi-form-section.twofa-form'), false);
              setTimeout(function () {
                self.show_error('conn-message');
                self.$refs.code.focus();
              });
            }
          });
        }).fail(function () {
          kendo.ui.progress($('.chi-form-section.twofa-form'), false);
          self.$root.auth_component = 'TwoFA';
          setTimeout(function () {
            self.clear();
            self.show_error('fail-message');
            self.$refs.code.focus();
          }, 300);
        });
      }
    },
    validate: function () {
      this.error.code = !this.model.code && this.model.code !== 0;
      if (this.error.code) {
        this.show_error('code-message');
        this.$refs.code.focus();
      }
      return !this.error.code;
    }
  },
  mounted: function () {
    $('#code').focus();
    var element = this.$options.errors = $('#chi-twofa-notifications');
    this.$options.notifications = new kendo.ui.Notification(element, {
      appendTo: '#chi-twofa-notifications',
      autoHideAfter: 10000,
      hide: function () {element.toggleClass('active', false)},
      show: function () {element.toggleClass('active', true)}
    });
    this.reset_delay();
  },
  //eslint-disable-next-line vue/no-dupe-keys
  props: ['destination', 'message_type', 'has_alternate']
};
</script>
